var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Artboard")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    strokeWidth: 2,
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(5.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crashes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crashes.Crashes-(with-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top-bar/filter-labels-dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-128",
    points: "0 2.52086749 3.98913274 6.5100002 10.499133 0"
  }))))))))))));
};
export default SvgDone;